import { sanitizeAppSettings } from './utility'

export const fetchAppSettings = async () => {
  const originUrl = window.location.origin

  const data = await fetch(`${originUrl}/environment.json`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })

  const appSettings = await data.json()

  return sanitizeAppSettings(appSettings)
}

export type EnvironmentSettings = {
  REACT_APP_CLIENT_ID: string
  REACT_APP_AUTHORITY: string

  /**
   * APIs
   */
  REACT_APP_COLLCALC_API_ENDPOINT?: string
  REACT_APP_COLLCALC_AUDIENCE?: string
  REACT_APP_COLLCALCTEST_API_ENDPOINT?: string
  REACT_APP_COLLCALCTEST_AUDIENCE?: string

  REACT_APP_CONFIGURATION_API_ENDPOINT?: string
  REACT_APP_CONFIGURATION_AUDIENCE?: string
  REACT_APP_CONFIGURATIONTEST_API_ENDPOINT?: string
  REACT_APP_CONFIGURATIONTEST_AUDIENCE?: string

  REACT_APP_LEGALENTITY_API_ENDPOINT?: string
  REACT_APP_LEGALENTITY_AUDIENCE?: string
  REACT_APP_LEGALENTITYTEST_API_ENDPOINT?: string
  REACT_APP_LEGALENTITYTEST_AUDIENCE?: string

  REACT_APP_LEGALENTITYDATAREPLICATOR_API_ENDPOINT?: string
  REACT_APP_LEGALENTITYDATAREPLICATOR_AUDIENCE?: string

  REACT_APP_LIFE_API_ENDPOINT?: string
  REACT_APP_LIFE_AUDIENCE?: string
  REACT_APP_LIFETEST_API_ENDPOINT?: string
  REACT_APP_LIFETEST_AUDIENCE?: string

  REACT_APP_LIFEDATAREPLICATOR_API_ENDPOINT?: string
  REACT_APP_LIFEDATAREPLICATOR_AUDIENCE?: string

  REACT_APP_MONEYIN_API_ENDPOINT?: string
  REACT_APP_MONEYIN_AUDIENCE?: string
  REACT_APP_MONEYINTEST_API_ENDPOINT?: string
  REACT_APP_MONEYINTEST_AUDIENCE?: string

  REACT_APP_MONEYOUT_API_ENDPOINT?: string
  REACT_APP_MONEYOUT_AUDIENCE?: string
  REACT_APP_MONEYOUTTEST_API_ENDPOINT?: string
  REACT_APP_MONEYOUTTEST_AUDIENCE?: string

  REACT_APP_DATAMART_API_ENDPOINT?: string
  REACT_APP_DATAMART_AUDIENCE?: string

  REACT_APP_DATAMART2_API_ENDPOINT?: string
  REACT_APP_DATAMART2_AUDIENCE?: string

  REACT_APP_MSGRAPH_API_ENDPOINT?: string

  REACT_APP_RESETTEST_AUDIENCE?: string
  REACT_APP_RESETTEST_API_ENDPOINT?: string

  REACT_APP_UNITLINK_API_ENDPOINT?: string
  REACT_APP_UNITLINK_AUDIENCE?: string
  REACT_APP_UNITLINKTEST_API_ENDPOINT?: string
  REACT_APP_UNITLINKTEST_AUDIENCE?: string

  REACT_APP_UNITLINKDATAREPLICATOR_API_ENDPOINT?: string
  REACT_APP_UNITLINKDATAREPLICATOR_AUDIENCE?: string

  /**
   * /APIs
   */

  REACT_APP_DOCUMENTATION_URL?: string

  REACT_APP_REDIRECT_URI?: string
  REACT_APP_USE_EXTERNAL_CRM?: boolean
  REACT_APP_TEST_MODE: boolean
  REACT_APP_SHOWUSERINFO: boolean
  REACT_APP_LOCAL_DEVELOPMENT?: boolean
  REACT_APP_PSEUDONYMIZATION_MONEYOUT_PAYMENTCHANNEL?: boolean
  REACT_APP_PSEUDONYMIZATION_MONEYOUT_PAYABLESTOP?: boolean

  // Certain clients may need additional URLs or different environment data.
  // See git history to learn what a possible type-safe(r) approach might look like.
  [extra: `REACT_APP_EXTRA_${string}_API_ENDPOINT`]: string
  [extra: `REACT_APP_EXTRA_${string}_AUDIENCE`]: string
}

export type AppSettings = {
  environments: Record<string, EnvironmentSettings>
}
